"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4903],{

/***/ 74903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(828);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10166);
/* harmony import */ var _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18722);
/* harmony import */ var hooks_useOpenControl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60335);
/* harmony import */ var hooks_useSimplex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57575);
/* harmony import */ var hooks_useMoonpay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3485);
/* harmony import */ var hooks_useTransak__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1);
/* harmony import */ var hooks_useWeb3Info__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29291);
/* harmony import */ var lib_network__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94511);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80871);
/* harmony import */ var data_crypto_token__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4042);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69583);
/* harmony import */ var _Redirect__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(20282);
/* eslint-disable react/function-component-definition */ /* eslint-disable import/extensions */ /* eslint-disable import/no-named-as-default */ 














var ModalContent = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e12uepp60"
})("display:flex;flex-direction:column;");
var BalanceBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e12uepp61"
})("display:flex;align-items:center;margin-bottom:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .spacing.xl */ .W0.xl, ";font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.h4 */ .JB.h4, ";font-weight:900;", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.down */ .AV.down("md"), "{font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.p1 */ .JB.p1, ";}");
var BalanceText = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("span", {
    target: "e12uepp62"
})("margin-left:0.5rem;color:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .palette.primary600 */ .DG.primary600, ";");
var AddFundsBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e12uepp63"
})("display:flex;flex-direction:column;gap:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .spacing.xxl */ .W0.xxl, ";padding:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .spacing.l */ .W0.l, ";margin-bottom:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .spacing.xl */ .W0.xl, ";border-radius:1rem;background-color:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .palette.gray200 */ .DG.gray200, ";button{display:flex;justify-content:space-between;align-items:center;width:100%;background-color:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .palette.white */ .DG.white, ";font-weight:600;}");
var AddFundsTitle = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("p", {
    target: "e12uepp64"
})("font-weight:700;text-align:center;");
var SymbolBox = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e12uepp65"
})("display:flex;align-items:center;justify-content:center;");
var DescriptionBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e12uepp66"
})("display:flex;flex-direction:column;");
var DescriptionText = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("p", {
    target: "e12uepp67"
})("text-align:center;", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.down */ .AV.down("lg"), "{font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.p4 */ .JB.p4, ";}");
var CardModalBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e12uepp68"
})("display:flex;flex-direction:column;align-items:center;justify-content:center;");
var CardModalTitle = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e12uepp69"
})("text-align:center;line-height:1.5;");
var CardModalContent = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e12uepp610"
})("display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;padding:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .spacing.l */ .W0.l, ";margin-top:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .spacing.xl */ .W0.xl, ";background-color:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .palette.gray200 */ .DG.gray200, ";border-radius:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .spacing.m */ .W0.m, ";& > span{margin-bottom:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .spacing.xl */ .W0.xl, ";}div{&:hover{opacity:0.8;}&:active{opacity:0.8;}}div + div{margin-top:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .spacing.m */ .W0.m, ";}");
var CardModalButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e12uepp611"
})("display:flex;justify-content:space-between;align-items:center;padding:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .spacing.s */ .W0.s, " ", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .spacing.xxl */ .W0.xxl, ";width:100%;height:", function(param) {
    var theme = param.theme;
    return theme.rem(48);
}, ";border:1px solid ", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .palette.black */ .DG.black, ";border-radius:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .spacing.xl */ .W0.xl, ";background-color:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .palette.white */ .DG.white, ";cursor:pointer;p{margin-right:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .spacing.xs */ .W0.xs, ";}");
var SymbolList = {
    polygon: {
        card: [
            "matic",
            "weth"
        ],
        swap: [
            "matic",
            "weth"
        ],
        desc: "You can buy Matic, WETH and PLA with your credit card."
    },
    ethereum: {
        card: [
            "eth"
        ],
        swap: [
            "eth",
            "weth"
        ],
        desc: "You can buy PLA and ETH with your credit card."
    },
    solana: {
        card: [],
        swap: [],
        desc: ""
    },
    klaytn: {
        card: [],
        swap: [],
        desc: ""
    }
};
var BalanceModal = function(param) {
    var isOpen = param.isOpen, currency = param.currency, balance = param.balance, handleOpen = param.handleOpen;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var chainId = (0,hooks_useWeb3Info__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().chainId;
    var ref12 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,hooks_useOpenControl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), 2), isCardModalOpen = ref12[0], handleCardModalOpen = ref12[1];
    var ref13 = (0,hooks_useSimplex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), SimplexModal = ref13.SimplexModal, isOpenSimplex = ref13.isOpen, handleOpenSimplex = ref13.handleOpen;
    var ref14 = (0,hooks_useMoonpay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), MoonPayModal = ref14.MoonPayModal, isOpenMoonpay = ref14.isOpen, handleOpenMoonpay = ref14.handleOpen;
    var handleOpenTransak = (0,hooks_useTransak__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().handleOpenTransak;
    var networkName = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return chainId ? lib_network__WEBPACK_IMPORTED_MODULE_8__/* .chainIdToMainNetworkName */ .$4[chainId] : "polygon";
    }, [
        chainId
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        handleOpen(false);
        handleCardModalOpen(false);
    }, [
        isOpenSimplex
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u_, {
                width: {
                    lg: "500px",
                    xl: "500px"
                },
                shouldCloseOnOverlayClick: true,
                isOpen: isOpen,
                handleOpen: handleOpen,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(ModalContent, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(BalanceBlock, {
                            children: [
                                "My Balance :",
                                " ",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(BalanceText, {
                                    children: balance ? "".concat((0,lib_util__WEBPACK_IMPORTED_MODULE_9__/* .setComma */ .Vb)(balance), " ").concat(currency === null || currency === void 0 ? void 0 : currency.toUpperCase()) : "-"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(AddFundsBlock, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(AddFundsTitle, {
                                    children: "Add Funds"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                    onClick: function() {
                                        handleCardModalOpen(true);
                                    },
                                    variant: "outline",
                                    color: "secondary",
                                    size: "lg",
                                    children: [
                                        "Buy with card",
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(SymbolBox, {
                                            children: (ref = SymbolList[networkName]) === null || ref === void 0 ? void 0 : ref.card.map(function(symbol) {
                                                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_Icon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    name: "currency-".concat(symbol),
                                                    size: 24,
                                                    alt: symbol
                                                }, "card-".concat(symbol));
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_Redirect__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    to: data_crypto_token__WEBPACK_IMPORTED_MODULE_10__/* .swapLinks */ .LA[networkName],
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                        variant: "outline",
                                        color: "secondary",
                                        size: "lg",
                                        children: [
                                            "Swap",
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(SymbolBox, {
                                                children: (ref1 = SymbolList[networkName]) === null || ref1 === void 0 ? void 0 : ref1.swap.map(function(symbol) {
                                                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_Icon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                        name: "currency-".concat(symbol),
                                                        size: 24,
                                                        alt: symbol
                                                    }, "swap-".concat(symbol));
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(DescriptionBlock, {
                            children: networkName === "ethereum" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(DescriptionText, {
                                children: [
                                    "You can buy",
                                    " ",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("b", {
                                        children: (ref3 = (ref2 = SymbolList[networkName]) === null || ref2 === void 0 ? void 0 : ref2.card[0]) === null || ref3 === void 0 ? void 0 : ref3.toUpperCase()
                                    }),
                                    " and",
                                    " ",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("b", {
                                        children: (ref5 = (ref4 = SymbolList[networkName]) === null || ref4 === void 0 ? void 0 : ref4.card[1]) === null || ref5 === void 0 ? void 0 : ref5.toUpperCase()
                                    }),
                                    " with your credit card."
                                ]
                            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(DescriptionText, {
                                children: [
                                    "You can buy",
                                    " ",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("b", {
                                        children: (ref7 = (ref6 = SymbolList[networkName]) === null || ref6 === void 0 ? void 0 : ref6.card[1]) === null || ref7 === void 0 ? void 0 : ref7.toUpperCase()
                                    }),
                                    ",",
                                    " ",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("b", {
                                        children: (ref9 = (ref8 = SymbolList[networkName]) === null || ref8 === void 0 ? void 0 : ref8.card[2]) === null || ref9 === void 0 ? void 0 : ref9.toUpperCase()
                                    }),
                                    " and",
                                    " ",
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("b", {
                                        children: (ref11 = (ref10 = SymbolList[networkName]) === null || ref10 === void 0 ? void 0 : ref10.card[0]) === null || ref11 === void 0 ? void 0 : ref11.toUpperCase()
                                    }),
                                    " with your credit card."
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u_, {
                width: {
                    lg: "500px",
                    xl: "500px"
                },
                isOpen: isCardModalOpen,
                handleOpen: handleCardModalOpen,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(CardModalBlock, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(CardModalTitle, {
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                type: "h4",
                                children: "Buy with card"
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(CardModalContent, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                    type: "b1",
                                    children: "Add Funds"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(CardModalButton, {
                                    onClick: function() {
                                        return handleOpenSimplex(!isOpenSimplex);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                            type: "b3",
                                            children: "To Simplex"
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_Icon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            name: "simplexLogo",
                                            width: 81,
                                            height: 39,
                                            alt: "card-brand"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(CardModalButton, {
                                    onClick: function() {
                                        return handleOpenMoonpay(!isOpenMoonpay);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                            type: "b3",
                                            children: "To Moonpay"
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_Icon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            name: "moonpayLogo",
                                            width: 81,
                                            height: 39,
                                            alt: "card-brand"
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(MoonPayModal, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(CardModalButton, {
                                    onClick: handleOpenTransak,
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                                            type: "b3",
                                            children: "To Transak"
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_Icon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            name: "transakLogo",
                                            width: 81,
                                            height: 39,
                                            alt: "card-brand"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(SimplexModal, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(BalanceModal));


/***/ }),

/***/ 3485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10166);
/* harmony import */ var _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18722);
/* harmony import */ var store_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57345);
/* harmony import */ var lib_network__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94511);






var MoonpayBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "eb7md9t0"
})("width:100%;height:600px;max-height:100%;position:relative;z-index:100;left:50%;top:50%;transform:translate(-50%,0%);background:white;border:none;border-radius:2%;margin:0px auto;display:block;form{background-color:white;}");
var MoonpayModal = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("iframe", {
    target: "eb7md9t1"
})("position:absolute;left:0;right:0;bottom:0;top:0;border:0;");
var useMoonpay = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var chainId = (0,store_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .C)(function(param) {
        var wallet = param.wallet;
        return wallet;
    }).chainId;
    var network = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return chainId ? lib_network__WEBPACK_IMPORTED_MODULE_4__/* .chainIdToMainNetworkName */ .$4[chainId] : null;
    }, [
        chainId
    ]);
    var handleOpen = function(isModalOpen) {
        setIsOpen(isModalOpen);
    };
    return {
        isOpen: isOpen,
        handleOpen: handleOpen,
        MoonPayModal: function() {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u_, {
                isOpen: isOpen,
                handleOpen: handleOpen,
                width: {
                    xxl: "500px",
                    sm: "400px"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(MoonpayBlock, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(MoonpayModal, {
                        allow: "accelerometer; autoplay; camera; gyroscope; payment",
                        width: "100%",
                        height: "100%",
                        frameBorder: "0",
                        src: "".concat( false ? 0 : "https://buy.moonpay.com/?apiKey=pk_live_bQoNMMaUsQ37Nl5hSjussHm1ws43qO".concat(network === "solana" ? "&defaultCurrencyCode=sol" : "")),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("p", {
                            children: "Your browser does not support iframes."
                        })
                    })
                })
            });
        }
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useMoonpay);


/***/ }),

/***/ 57575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useSimplex; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@playdapp/ui/dist/index.esm.js
var index_esm = __webpack_require__(18722);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useMedia.js
var useMedia = __webpack_require__(94829);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(10166);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/skeleton/dist/chakra-ui-skeleton.esm.js + 1 modules
var chakra_ui_skeleton_esm = __webpack_require__(7983);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/chakra-ui-input.esm.js
var chakra_ui_input_esm = __webpack_require__(4612);
;// CONCATENATED MODULE: ./src/api/simplex.ts


var getSimplexQuote = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var end_user_id, network, digital_currency, fiat_currency, requested_currency, requested_amount;
        return (0,tslib_es6.__generator)(this, function(_state) {
            end_user_id = param.end_user_id, network = param.network, digital_currency = param.digital_currency, fiat_currency = param.fiat_currency, requested_currency = param.requested_currency, requested_amount = param.requested_amount;
            return [
                2,
                fetch( false ? 0 : "https://a3w4ujg4j1.execute-api.ap-southeast-1.amazonaws.com/prod/simplex/quote", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        end_user_id: end_user_id,
                        network: network,
                        digital_currency: digital_currency,
                        fiat_currency: fiat_currency,
                        requested_currency: requested_currency,
                        requested_amount: requested_amount
                    })
                }).then(function(res) {
                    return res.json();
                })
            ];
        });
    });
    return function getSimplexQuote(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSimplexPurchase = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var app_end_user_id, quote_id, currency, address, network;
        return (0,tslib_es6.__generator)(this, function(_state) {
            app_end_user_id = param.app_end_user_id, quote_id = param.quote_id, currency = param.currency, address = param.address, network = param.network;
            return [
                2,
                fetch( false ? 0 : "https://a3w4ujg4j1.execute-api.ap-southeast-1.amazonaws.com/prod/simplex/partner/data", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        app_end_user_id: app_end_user_id,
                        quote_id: quote_id,
                        currency: currency,
                        address: address,
                        network: network
                    })
                }).then(function(res) {
                    return res.json();
                })
            ];
        });
    });
    return function getSimplexPurchase(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/lib/util.ts
var util = __webpack_require__(80871);
// EXTERNAL MODULE: ./src/store/hooks.ts
var hooks = __webpack_require__(57345);
// EXTERNAL MODULE: ./src/lib/network/index.ts
var lib_network = __webpack_require__(94511);
// EXTERNAL MODULE: ./src/hooks/useOpenControl.ts
var useOpenControl = __webpack_require__(60335);
// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(68663);
;// CONCATENATED MODULE: ./src/components/Modal/SimplexConfirmModal.tsx







var ModalContents = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezn5str0"
})("@media (min-height:480px) and (max-width:480px){max-height:80vh;overflow-y:scroll;}@media (max-height:480px){max-height:60vh;overflow-y:scroll;}");
var TitleBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezn5str1"
})("text-align:center;");
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "ezn5str2"
})((0,index_esm/* fontStyle */.p_)("h4"), ";", index_esm/* breakpoints.down */.AV.down("sm"), "{", (0,index_esm/* fontStyle */.p_)("h5"), ";}");
var SubTitleBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezn5str3"
})("margin-top:", index_esm/* spacing.xs */.W0.xs, ";margin-bottom:", index_esm/* spacing.m */.W0.m, ";text-align:center;");
var SubTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "ezn5str4"
})((0,index_esm/* fontStyle */.p_)("p3"), ";color:", index_esm/* palette.gray900 */.DG.gray900, ";");
var ContentsBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezn5str5"
})("width:100%;padding:", index_esm/* spacing.l */.W0.l, ";background-color:", index_esm/* palette.gray200 */.DG.gray200, ";border-radius:16px;");
var ContentsTop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezn5str6"
})("padding-bottom:", index_esm/* spacing.m */.W0.m, ";border-bottom:1px solid #d9d9d9;", index_esm/* breakpoints.down */.AV.down("sm"), "{padding-bottom:", index_esm/* spacing.s */.W0.s, ";}");
var ContentsRow = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezn5str7"
})("display:flex;align-items:center;justify-content:space-between;& + &{margin-top:", index_esm/* spacing.s */.W0.s, ";}");
var ContentsName = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "ezn5str8"
})((0,index_esm/* fontStyle */.p_)("p4"), ";color:", index_esm/* palette.gray900 */.DG.gray900, ";");
var ContentsValue = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "ezn5str9"
})((0,index_esm/* fontStyle */.p_)("b3"), ";color:", index_esm/* palette.black */.DG.black, ";");
var ContentsBottom = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezn5str10"
})("padding-top:", index_esm/* spacing.m */.W0.m, ";text-align:center;p:nth-of-type(1){", (0,index_esm/* fontStyle */.p_)("p5"), ";color:", index_esm/* palette.gray900 */.DG.gray900, ";}p:nth-of-type(2){margin-top:", index_esm/* spacing.xs */.W0.xs, ";", (0,index_esm/* fontStyle */.p_)("p4"), ";color:", index_esm/* palette.black */.DG.black, ";}", index_esm/* breakpoints.down */.AV.down("sm"), "{padding-top:", index_esm/* spacing.s */.W0.s, ";}");
var DisclaimerBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezn5str11"
})("margin-top:", index_esm/* spacing.xl */.W0.xl, ";padding-bottom:", index_esm/* spacing.m */.W0.m, ";border-bottom:1px solid #d9d9d9;");
var DisclaimerTitleBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezn5str12"
})("margin-bottom:", index_esm/* spacing.xs */.W0.xs, ";span{", (0,index_esm/* fontStyle */.p_)("b4"), ";color:", index_esm/* palette.black */.DG.black, ";}");
var DisclaimerContents = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "ezn5str13"
})((0,index_esm/* fontStyle */.p_)("p5"), ";color:", index_esm/* palette.gray900 */.DG.gray900, ";span{color:", index_esm/* palette.primary600 */.DG.primary600, ";}");
var CheckBoxBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezn5str14"
})("margin-top:", index_esm/* spacing.m */.W0.m, ";form > div{margin-bottom:0;label{padding-left:4px;line-height:2.1 !important;", (0,index_esm/* fontStyle */.p_)("p4"), ";color:", index_esm/* palette.black */.DG.black, ";}}");
var ButtonBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezn5str15"
})("display:flex;justify-content:space-between;gap:1rem;margin-top:", index_esm/* spacing.xl */.W0.xl, ";button{width:50%;height:auto;min-height:2.5rem;}", index_esm/* breakpoints.down */.AV.down("sm"), "{align-items:space-between;justify-content:center;button{width:100%;}}");
var SimplexConfirmModal = function(param) {
    var digitalAmount = param.digitalAmount, digitalCurrency = param.digitalCurrency, fiatAmount = param.fiatAmount, fiatCurrency = param.fiatCurrency, isOpen = param.isOpen, handleOpen = param.handleOpen, confirmData = param.confirmData;
    var ref = (0,react.useState)(false), isAgree = ref[0], setIsAgree = ref[1];
    var account = (0,hooks/* useAppSelector */.C)(function(param) {
        var wallet = param.wallet;
        return wallet;
    }).account;
    var isSmDownScreen = (0,useMedia/* default */.Z)((0,util/* getBreakpointQuery */.XR)(index_esm/* breakpoints.down */.AV.down("sm")));
    var handleIsAgree = function() {
        setIsAgree(!isAgree);
    };
    var handleClickConfirm = function() {
        var form = document.createElement("form");
        form.setAttribute("id", "simplex-form");
        form.setAttribute("target", "simplex-form");
        form.setAttribute("method", "".concat(confirmData.method));
        form.setAttribute("action", "".concat(confirmData.action));
        if (confirmData) {
            var objList = [
                {
                    name: "version",
                    value: "".concat(confirmData.version)
                },
                {
                    name: "partner",
                    value: "".concat(confirmData.partner)
                },
                {
                    name: "return_url_success",
                    value: "".concat(confirmData.return_url_success)
                },
                {
                    name: "return_url_fail",
                    value: "".concat(confirmData.return_url_fail)
                },
                {
                    name: "payment_id",
                    value: "".concat(confirmData === null || confirmData === void 0 ? void 0 : confirmData.payment_id)
                }, 
            ];
            objList.forEach(function(item) {
                var obj = document.createElement("input");
                obj.setAttribute("type", "hidden");
                obj.setAttribute("name", item.name);
                obj.setAttribute("value", item.value);
                form.appendChild(obj);
            });
            document.body.appendChild(form);
            window.open("about:blank", "simplex-form");
            form.submit();
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Modal */.u_, {
        isOpen: isOpen,
        width: {
            xl: "498px",
            lg: "498px",
            md: "498px"
        },
        handleOpen: handleOpen,
        shouldCloseOnOverlayClick: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModalContents, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TitleBlock, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                        children: "Buy with simplex"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubTitleBlock, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubTitle, {
                        children: "Confirm your order"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentsBlock, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentsTop, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentsRow, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentsName, {
                                            children: "Estimated amount"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentsValue, {
                                            children: [
                                                digitalAmount,
                                                " ",
                                                digitalCurrency
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentsRow, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentsName, {
                                            children: "Total"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentsValue, {
                                            children: [
                                                fiatAmount,
                                                " ",
                                                fiatCurrency
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentsBottom, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                    children: "Deposit to address of exchange account"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                    children: isSmDownScreen ? (0,util/* convertAddress */.US)(account || "") : account || ""
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DisclaimerBlock, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisclaimerTitleBox, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                children: "Disclaimer"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DisclaimerContents, {
                            children: [
                                "You will now leave PlayDapp Market and jump to",
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    children: "Simplex.com"
                                }),
                                ". Please contact",
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    children: "support@simplex.com"
                                }),
                                " for any questions. PlayDapp does not assume any responsibility for any loss or damage caused by the use of the credit card payment service."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckBoxBlock, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Form */.l0, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Form.Check */.l0.Check, {
                            id: "agree",
                            name: "agree",
                            checked: isAgree,
                            onChange: handleIsAgree,
                            children: "I have read and agreed the disclamer"
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ButtonBlock, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Button */.zx, {
                            variant: "outline",
                            color: "black",
                            onClick: function() {
                                return handleOpen(false);
                            },
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Button */.zx, {
                            disabled: !isAgree,
                            onClick: handleClickConfirm,
                            children: "Pay now"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Modal_SimplexConfirmModal = (SimplexConfirmModal);

;// CONCATENATED MODULE: ./src/hooks/useSimplex.tsx





















var CardModalBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1uldyu20"
})("display:flex;flex-direction:column;align-items:center;justify-content:center;");
var SkeletonBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1uldyu21"
})("display:flex;flex-direction:column;justify-content:space-between;align-items:center;width:418px;height:226px;margin-top:", index_esm/* spacing.m */.W0.m, ";padding:", index_esm/* spacing.l */.W0.l, ";background:", index_esm/* palette.gray200 */.DG.gray200, ";border-radius:16px;");
var useSimplex_Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1uldyu22"
})("margin-bottom:", index_esm/* spacing.xs */.W0.xs, ";font-weight:800;font-size:24px;", index_esm/* breakpoints.down */.AV.down("md"), "{font-size:20px;}");
var ContentBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1uldyu23"
})("margin-top:", index_esm/* spacing.m */.W0.m, ";form{display:flex;flex-direction:column;align-items:center;}");
var InputWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1uldyu24"
})("margin-bottom:", index_esm/* spacing.l */.W0.l, ";padding:", index_esm/* spacing.l */.W0.l, ";background:", index_esm/* palette.gray200 */.DG.gray200, ";border-radius:16px;");
var InputSection = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1uldyu25"
})("margin-bottom:", index_esm/* spacing.m */.W0.m, ";");
var InputBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1uldyu26"
})("display:flex;justify-content:space-between;align-items:center;width:376px;margin:", index_esm/* spacing.xs */.W0.xs, " 0 ", index_esm/* spacing.xxs */.W0.xxs, " 0;padding:", index_esm/* spacing.s */.W0.s, ";background:", index_esm/* palette.white */.DG.white, ";border:1px solid ", index_esm/* palette.gray600 */.DG.gray600, ";border-radius:8px;input{width:70%;height:90%;", (0,index_esm/* fontStyle */.p_)("p3"), ";}", index_esm/* breakpoints.down */.AV.down("md"), "{max-width:262px;min-width:230px;margin:0 auto;input{", (0,index_esm/* fontStyle */.p_)("p4"), ";}}");
var DigitalInputBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1uldyu27"
})("display:flex;justify-content:flex-end;align-items:center;width:376px;margin:", index_esm/* spacing.xs */.W0.xs, " 0 ", index_esm/* spacing.xxs */.W0.xxs, " 0;padding:", index_esm/* spacing.s */.W0.s, ";background:", index_esm/* palette.white */.DG.white, ";border:1px solid ", index_esm/* palette.gray600 */.DG.gray600, ";border-radius:8px;", index_esm/* breakpoints.down */.AV.down("md"), "{max-width:262px;min-width:230px;margin:0 auto;}");
var FiatCurrencySelect = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("select", {
    target: "e1uldyu28"
})("width:20%;text-align:center;", (0,index_esm/* fontStyle */.p_)("b4"), ";", index_esm/* breakpoints.down */.AV.down("md"), "{", (0,index_esm/* fontStyle */.p_)("b5"), ";}");
var DigitalCurrencySelect = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("select", {
    target: "e1uldyu29"
})((0,index_esm/* fontStyle */.p_)("b4"), ";", index_esm/* breakpoints.down */.AV.down("md"), "{", (0,index_esm/* fontStyle */.p_)("b5"), ";}");
var DigitalCurrencyBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1uldyu210"
})("width:100%;text-align:right;", (0,index_esm/* fontStyle */.p_)("b4"), ";", index_esm/* breakpoints.down */.AV.down("md"), "{", (0,index_esm/* fontStyle */.p_)("b5"), ";}");
var DigitalCurrencyErrorText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e1uldyu211"
})((0,index_esm/* fontStyle */.p_)("p4"), ";color:", index_esm/* palette.red */.DG.red, ";");
var ErrorBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1uldyu212"
})("margin-top:", index_esm/* spacing.xxs */.W0.xxs, ";", (0,index_esm/* fontStyle */.p_)("p5"), ";color:", index_esm/* palette.red500 */.DG.red500, ";");
var useSimplex = function() {
    var isMdDown = (0,useMedia/* default */.Z)((0,util/* getBreakpointQuery */.XR)(index_esm/* breakpoints.down */.AV.down("md")), false);
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useOpenControl/* default */.Z)(), 2), isConfirmModalOpen = ref1[0], handleConfirmModalOpen = ref1[1];
    var ref2 = (0,react.useState)(""), errorMessage = ref2[0], setErrorMessage = ref2[1];
    var ref3 = (0,react.useState)(false), isLoadingSubmit = ref3[0], setLoadingSubmit = ref3[1];
    var ref4 = (0,react.useState)(null), orderData = ref4[0], setOrderData = ref4[1];
    var ref5 = (0,react.useState)(null), confirmData = ref5[0], setConfirmData = ref5[1];
    var ref6 = (0,hooks/* useAppSelector */.C)(function(param) {
        var wallet = param.wallet;
        return wallet;
    }), account = ref6.account, chainId = ref6.chainId;
    var network = lib_network/* chainIdToMainNetworkName */.$4[chainId || 137];
    var ref7 = (0,es.useQuery)("getSimplexQuote", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, quoteData;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!account) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        getSimplexQuote({
                            end_user_id: account,
                            network: network
                        })
                    ];
                case 1:
                    ref = _state.sent(), quoteData = ref.data;
                    if (quoteData) {
                        setValue("digital_currency", quoteData === null || quoteData === void 0 ? void 0 : quoteData.supported_digital_currencies[0]);
                        setValue("fiat_currency", quoteData === null || quoteData === void 0 ? void 0 : quoteData.supported_fiat_currencies[0]);
                    }
                    return [
                        2,
                        quoteData
                    ];
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), {
        enabled: !!account,
        refetchOnWindowFocus: false
    }), isLoading = ref7.isLoading, quoteData = ref7.data;
    var ref8 = (0,dist_index_esm/* useForm */.cI)({
        mode: "onSubmit",
        reValidateMode: "onSubmit"
    }), register = ref8.register, handleSubmit = ref8.handleSubmit, setValue = ref8.setValue, getValues = ref8.getValues, reset = ref8.reset, errors = ref8.formState.errors;
    var handleOpen = function(isModalOpen) {
        setIsOpen(isModalOpen);
    };
    var handleClickSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, digitalCurrency, ref1, submitData, message, ref2, purchaseData, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!account) return [
                            3,
                            7
                        ];
                        digitalCurrency = (ref = getValues("digital_currency")) !== null && ref !== void 0 ? ref : quoteData === null || quoteData === void 0 ? void 0 : quoteData.supported_digital_currencies[0];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            6,
                            7
                        ]);
                        setLoadingSubmit(true);
                        return [
                            4,
                            getSimplexQuote({
                                end_user_id: account,
                                network: network,
                                digital_currency: digitalCurrency,
                                fiat_currency: getValues("fiat_currency"),
                                requested_currency: getValues("fiat_currency"),
                                requested_amount: getValues("requested_amount")
                            })
                        ];
                    case 2:
                        ref1 = _state.sent(), submitData = ref1.data, message = ref1.message;
                        if (message) {
                            setErrorMessage(message);
                        }
                        if (!submitData) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            getSimplexPurchase({
                                app_end_user_id: account,
                                quote_id: submitData === null || submitData === void 0 ? void 0 : submitData.quote_id,
                                currency: digitalCurrency,
                                address: account,
                                network: network
                            })
                        ];
                    case 3:
                        ref2 = _state.sent(), purchaseData = ref2.data;
                        setOrderData(submitData);
                        if (purchaseData) {
                            setConfirmData(purchaseData);
                            handleConfirmModalOpen(true);
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            2,
                            submitData
                        ];
                    case 5:
                        e = _state.sent();
                        setLoadingSubmit(false);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        setLoadingSubmit(false);
                        return [
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClickSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        reset();
        setErrorMessage("Success");
        setLoadingSubmit(false);
    }, [
        isOpen
    ]);
    return {
        isOpen: isOpen,
        handleOpen: handleOpen,
        SimplexModal: function() {
            var ref, ref1;
            /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Modal */.u_, {
                        isOpen: isOpen,
                        handleOpen: handleOpen,
                        width: {
                            lg: "498px",
                            xl: "498px"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardModalBlock, {
                            children: [
                                isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_skeleton_esm/* Skeleton */.Od, {
                                            width: "100%",
                                            height: 57,
                                            borderRadius: 8
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkeletonBlock, {
                                            children: (0,lodash.times)(2, function(index) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_skeleton_esm/* Skeleton */.Od, {
                                                    width: "100%",
                                                    height: 78,
                                                    borderRadius: 8
                                                }, index);
                                            })
                                        })
                                    ]
                                }),
                                !isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(useSimplex_Title, {
                                            children: "Buy with Simplex"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                            type: isMdDown ? "p4" : "p3",
                                            color: "gray900",
                                            children: "Enter the amount of fiat money"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentBlock, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
                                                onSubmit: handleSubmit(handleClickSubmit),
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InputWrapper, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InputSection, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                                        type: isMdDown ? "b4" : "b3",
                                                                        children: "Fiat Currency"
                                                                    }),
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InputBlock, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_input_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                                                                                variant: "unstyled",
                                                                                type: "number",
                                                                                placeholder: "Please type number."
                                                                            }, register("requested_amount", {
                                                                                required: "Number is required."
                                                                            }))),
                                                                            quoteData && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FiatCurrencySelect, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("fiat_currency")), {
                                                                                children: quoteData.supported_fiat_currencies.map(function(fiatCurrency) {
                                                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                                                                                        value: fiatCurrency,
                                                                                        children: fiatCurrency
                                                                                    }, fiatCurrency);
                                                                                })
                                                                            }))
                                                                        ]
                                                                    }),
                                                                    ((ref = errors.requested_amount) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorBlock, {
                                                                        children: (ref1 = errors.requested_amount) === null || ref1 === void 0 ? void 0 : ref1.message
                                                                    }),
                                                                    errorMessage !== "Success" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorBlock, {
                                                                        children: errorMessage
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InputSection, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                                        type: isMdDown ? "b4" : "b3",
                                                                        children: "Digital Currency"
                                                                    }),
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DigitalInputBlock, {
                                                                        children: quoteData && (quoteData === null || quoteData === void 0 ? void 0 : quoteData.supported_digital_currencies.length) > 1 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DigitalCurrencySelect, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("digital_currency")), {
                                                                            children: quoteData === null || quoteData === void 0 ? void 0 : quoteData.supported_digital_currencies.map(function(digitalCurrency) {
                                                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                                                                                    value: digitalCurrency,
                                                                                    children: digitalCurrency
                                                                                }, digitalCurrency);
                                                                            })
                                                                        })) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DigitalCurrencyBlock, {
                                                                            children: quoteData ? quoteData.supported_digital_currencies[0] : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DigitalCurrencyErrorText, {
                                                                                children: "An unexpected error occurred. please try again."
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    isLoadingSubmit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Progress */.Ex, {
                                                        size: "large"
                                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                                        type: "submit",
                                                        isDisabled: !quoteData,
                                                        children: "Confirm your order"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    orderData && confirmData && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal_SimplexConfirmModal, {
                        isOpen: isConfirmModalOpen,
                        handleOpen: handleConfirmModalOpen,
                        fiatAmount: orderData.fiat_money.total_amount,
                        fiatCurrency: orderData === null || orderData === void 0 ? void 0 : orderData.fiat_money.currency,
                        digitalAmount: orderData.digital_money.amount,
                        digitalCurrency: orderData.digital_money.currency,
                        confirmData: confirmData
                    })
                ]
            });
        }
    };
};
/* harmony default export */ var hooks_useSimplex = (useSimplex);


/***/ }),

/***/ 1:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var store_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57345);
/* harmony import */ var _transak_transak_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90852);
/* harmony import */ var _transak_transak_sdk__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_transak_transak_sdk__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lib_network__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94511);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* eslint-disable @typescript-eslint/ban-ts-comment */ 



/* @ts-ignore */ 


var useTransak = function() {
    var ref = (0,store_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useAppSelector */ .C)(function(param) {
        var wallet = param.wallet;
        return wallet;
    }), account = ref.account, chainId = ref.chainId;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var transak = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var nativeCurrencyName = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            1: "eth",
            11155111: "eth",
            137: "matic",
            80002: "matic",
            devnet: "sol",
            "mainnet-beta": "sol",
            1001: "klay",
            8217: "klay"
        };
    }, []);
    var handleOpenTransak = function() {
        if (!account || !chainId) {
            return;
        }
        var settings = {
            apiKey: "109a626a-1be8-48c5-ad26-3d2684007f7e",
            environment:  false ? 0 : "PRODUCTION",
            defaultCryptoCurrency: nativeCurrencyName[chainId || 137].toUpperCase(),
            themeColor: "000000",
            hostURL: window.location.origin,
            networks: lib_network__WEBPACK_IMPORTED_MODULE_3__/* .chainIdToMainNetworkName */ .$4[chainId || 137],
            disableWalletAddressForm: true,
            widgetHeight: "600px"
        };
        var transakInstance = new (_transak_transak_sdk__WEBPACK_IMPORTED_MODULE_2___default())((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, settings), {
            walletAddress: account
        }));
        transak.current = transakInstance;
        transakInstance.init();
        // This will trigger when the user closed the widget
        transakInstance.on(transakInstance.EVENTS.TRANSAK_WIDGET_CLOSE, function() {
            transakInstance.close();
        });
        // This will trigger when the user marks payment is made.
        transakInstance.on(transakInstance.EVENTS.TRANSAK_ORDER_SUCCESSFUL, function() {
            transakInstance.close();
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        router.events.on("routeChangeStart", function() {
            if (transak.current) {
                var htmlElement = document.querySelector("html");
                if (htmlElement) {
                    htmlElement.style.overflow = "scroll";
                }
                /* @ts-ignore */ transak.current.close();
            }
        });
    }, [
        router
    ]);
    return {
        handleOpenTransak: handleOpenTransak
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTransak);


/***/ })

}]);